import React from 'react';
import Button from '../../components/shared/Button';

// Arrow icon for buttons
const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
  </svg>
);

// Plus icon for buttons
const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
  </svg>
);

export default function StylesPage() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-heading mb-8 text-brand-navy">Original Pancake House Style Guide</h1>
      
      {/* Color Palette */}
      <section className="mb-16">
        <h2 className="text-3xl font-heading mb-6 text-brand-navy">Color Palette</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="flex flex-col">
            <div className="h-24 bg-brand-navy rounded"></div>
            <p className="mt-2 font-medium">Navy</p>
            <p className="text-sm text-gray-600">#082442</p>
          </div>
          <div className="flex flex-col">
            <div className="h-24 bg-brand-cream rounded border border-gray-200"></div>
            <p className="mt-2 font-medium">Cream</p>
            <p className="text-sm text-gray-600">#FFF8F1</p>
          </div>
          <div className="flex flex-col">
            <div className="h-24 bg-brand-lightgrey rounded border border-gray-200"></div>
            <p className="mt-2 font-medium">Light Grey</p>
            <p className="text-sm text-gray-600">#fafafa</p>
          </div>
          <div className="flex flex-col">
            <div className="h-24 bg-brand-grey rounded"></div>
            <p className="mt-2 font-medium">Accent Grey</p>
            <p className="text-sm text-gray-600">#d5d5d5</p>
          </div>
        </div>
      </section>
      
      {/* Typography */}
      <section className="mb-16">
        <h2 className="text-3xl font-heading mb-6 text-brand-navy">Typography</h2>
        
        <div className="mb-8">
          <h3 className="text-xl mb-4">Headings</h3>
          <div className="space-y-4">
            <div>
              <h1 className="font-heading text-5xl">Heading 1</h1>
              <p className="text-sm text-gray-600 mt-1">Air Americana - 3rem/48px</p>
            </div>
            <div>
              <h2 className="font-heading text-4xl">Heading 2</h2>
              <p className="text-sm text-gray-600 mt-1">Air Americana - 2.25rem/36px</p>
            </div>
            <div>
              <h3 className="font-heading text-3xl">Heading 3</h3>
              <p className="text-sm text-gray-600 mt-1">Air Americana - 1.875rem/30px</p>
            </div>
            <div>
              <h4 className="font-heading text-2xl">Heading 4</h4>
              <p className="text-sm text-gray-600 mt-1">Air Americana - 1.5rem/24px</p>
            </div>
            <div>
              <h5 className="font-heading text-xl">Heading 5</h5>
              <p className="text-sm text-gray-600 mt-1">Air Americana - 1.25rem/20px</p>
            </div>
          </div>
        </div>
        
        <div>
          <h3 className="text-xl mb-4">Body Text</h3>
          <div className="space-y-4">
            <div>
              <p className="text-lg">Large Body Text - This is a sample of the large body text used throughout the site.</p>
              <p className="text-sm text-gray-600 mt-1">DM Sans - 1.125rem/18px</p>
            </div>
            <div>
              <p>Regular Body Text - This is a sample of the regular body text used throughout the site.</p>
              <p className="text-sm text-gray-600 mt-1">DM Sans - 1rem/16px</p>
            </div>
            <div>
              <p className="text-sm">Small Text - This is a sample of the small text used throughout the site.</p>
              <p className="text-sm text-gray-600 mt-1">DM Sans - 0.875rem/14px</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Buttons */}
      <section className="mb-16">
        <h2 className="text-3xl font-heading mb-6 text-brand-navy">Buttons</h2>
        
        {/* Solid Buttons */}
        <div className="mb-8">
          <h3 className="text-xl mb-4">Solid Buttons</h3>
          <div className="flex flex-wrap gap-4">
            <Button variant="solid" color="navy" icon={<ArrowIcon />}>
              Order Online
            </Button>
            <Button variant="solid" color="cream" icon={<ArrowIcon />}>
              Order Online
            </Button>
          </div>
        </div>
        
        {/* Outline Buttons */}
        <div className="mb-8">
          <h3 className="text-xl mb-4">Outline Buttons</h3>
          <div className="flex flex-wrap gap-4">
            <Button variant="outline" color="navy" icon={<ArrowIcon />}>
              Order Online
            </Button>
            <div className="p-4 bg-brand-navy">
              <Button variant="outline" color="cream" icon={<ArrowIcon />}>
                Order Online
              </Button>
            </div>
          </div>
        </div>
        
        {/* Glass Buttons */}
        <div className="mb-8">
          <h3 className="text-xl mb-4">Glass Buttons</h3>
          <div className="flex flex-wrap gap-4">
            <div className="relative p-4 overflow-hidden">
              <div className="absolute inset-0 bg-[url('/images/hero/blueberry-pancakes-original-pancake-house.jpg')] bg-cover opacity-50"></div>
              <div className="relative z-10">
                <Button variant="glass" color="navy" icon={<ArrowIcon />}>
                  Order Online
                </Button>
              </div>
            </div>
            <div className="relative p-4 overflow-hidden">
              <div className="absolute inset-0 bg-[url('/images/hero/french-toast-original-pancake-house-hero.jpg')] bg-cover opacity-50"></div>
              <div className="relative z-10">
                <Button variant="glass" color="cream" icon={<ArrowIcon />}>
                  Order Online
                </Button>
              </div>
            </div>
            <div className="relative p-4 overflow-hidden">
              <div className="absolute inset-0 bg-[url('/images/hero/california-burrito-original-pancake-house.jpg')] bg-cover opacity-50"></div>
              <div className="relative z-10">
                <Button variant="glass" color="white" icon={<PlusIcon />}>
                  Join Waitlist
                </Button>
              </div>
            </div>
          </div>
        </div>
        
        {/* Buttons without icons */}
        <div className="mb-8">
          <h3 className="text-xl mb-4">Buttons Without Icons</h3>
          <div className="flex flex-wrap gap-4">
            <Button variant="solid" color="navy">
              Join Waitlist
            </Button>
            <Button variant="outline" color="navy">
              Join Waitlist
            </Button>
          </div>
        </div>
      </section>
      
      {/* Form Elements */}
      <section className="mb-16">
        <h2 className="text-3xl font-heading mb-6 text-brand-navy">Form Elements</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Text Inputs */}
          <div>
            <h3 className="text-xl mb-4">Text Inputs</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1" htmlFor="default-input">Default Input</label>
                <input 
                  type="text" 
                  id="default-input" 
                  className="w-full px-4 py-2 border-2 border-brand-grey focus:border-brand-navy focus:outline-none transition-colors" 
                  placeholder="Enter your name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1" htmlFor="focused-input">Focused Input</label>
                <input 
                  type="text" 
                  id="focused-input" 
                  className="w-full px-4 py-2 border-2 border-brand-navy focus:outline-none" 
                  placeholder="Enter your email"
                  defaultValue="example@email.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1" htmlFor="error-input">Error Input</label>
                <input 
                  type="text" 
                  id="error-input" 
                  className="w-full px-4 py-2 border-2 border-red-500 focus:outline-none" 
                  placeholder="Enter your phone"
                />
                <p className="text-red-500 text-sm mt-1">Please enter a valid phone number</p>
              </div>
            </div>
          </div>
          
          {/* Selects and Checkboxes */}
          <div>
            <h3 className="text-xl mb-4">Select & Checkboxes</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1" htmlFor="default-select">Default Select</label>
                <select 
                  id="default-select" 
                  className="w-full px-4 py-2 border-2 border-brand-grey focus:border-brand-navy focus:outline-none transition-colors"
                >
                  <option value="">Select a location</option>
                  <option value="seattle">Seattle</option>
                  <option value="portland">Portland</option>
                  <option value="vancouver">Vancouver</option>
                </select>
              </div>
              
              <div className="mt-4">
                <div className="flex items-center">
                  <input 
                    type="checkbox" 
                    id="default-checkbox" 
                    className="w-5 h-5 text-brand-navy focus:ring-brand-navy"
                  />
                  <label htmlFor="default-checkbox" className="ml-2">Subscribe to newsletter</label>
                </div>
              </div>
              
              <div className="mt-4">
                <div className="flex items-center">
                  <input 
                    type="radio" 
                    id="default-radio" 
                    name="radio-group"
                    className="w-5 h-5 text-brand-navy focus:ring-brand-navy"
                  />
                  <label htmlFor="default-radio" className="ml-2">Dine in</label>
                </div>
                <div className="flex items-center mt-2">
                  <input 
                    type="radio" 
                    id="default-radio-2" 
                    name="radio-group"
                    className="w-5 h-5 text-brand-navy focus:ring-brand-navy"
                  />
                  <label htmlFor="default-radio-2" className="ml-2">Take out</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Cards */}
      <section className="mb-16">
        <h2 className="text-3xl font-heading mb-6 text-brand-navy">Cards</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Basic Card */}
          <div className="bg-white shadow-md">
            <img 
              src="/images/hero/blueberry-pancakes-original-pancake-house.jpg" 
              alt="Blueberry Pancakes" 
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="text-xl font-heading">Blueberry Pancakes</h3>
              <p className="mt-2">Our signature blueberry pancakes made with fresh blueberries and topped with whipped cream.</p>
              <div className="mt-4">
                <Button variant="solid" color="navy" className="w-full">
                  Order Now
                </Button>
              </div>
            </div>
          </div>
          
          {/* Menu Card */}
          <div className="bg-white shadow-md">
            <img 
              src="/images/hero/french-toast-original-pancake-house-hero.jpg" 
              alt="French Toast" 
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-heading">French Toast</h3>
                <span className="font-medium">$12.99</span>
              </div>
              <p className="mt-2">Thick-cut bread dipped in our special batter and grilled to perfection.</p>
              <div className="mt-4 flex justify-between">
                <span className="text-sm bg-brand-cream px-2 py-1">Breakfast</span>
                <Button variant="outline" color="navy" className="text-sm px-3 py-1">
                  Add to Order
                </Button>
              </div>
            </div>
          </div>
          
          {/* Location Card */}
          <div className="bg-white shadow-md">
            <img 
              src="/images/hero/california-burrito-original-pancake-house.jpg" 
              alt="Restaurant Location" 
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="text-xl font-heading">Seattle Downtown</h3>
              <p className="mt-2">123 Pike Street, Seattle, WA 98101</p>
              <div className="mt-2 text-sm">
                <p>Mon-Fri: 7am - 2pm</p>
                <p>Sat-Sun: 7am - 3pm</p>
              </div>
              <div className="mt-4 flex space-x-2">
                <Button variant="solid" color="navy" className="flex-1 text-sm">
                  Directions
                </Button>
                <Button variant="outline" color="navy" className="flex-1 text-sm">
                  Menu
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
